/* istanbul ignore file -- @preserve */
import { useMutation } from '@apollo/client';
import createGlobalContactMutation from './createGlobalContactMutation.graphql';

const useCreateGlobalContactMutation = (options = {}) => {
  return useMutation<
    CreateGlobalContactMutationPayload,
    CreateGlobalContactMutationInput
  >(createGlobalContactMutation, {
    refetchQueries: ['ManagedPlatformAccountContacts', 'DepotContacts'],
    ...options,
  });
};

export default useCreateGlobalContactMutation;
